//export const API_URL = 'http://localhost:8020/api';

//planificacion-back-5xm6nmeia-alexis-castillos-projects.vercel.app

//export const API_URL = 'https://backend-planificacion.onrender.com/api';

export const API_URL ='https://tonygames25-001-site3.ptempurl.com/api'
//export const API_URL ='http://localhost:8020/api'